import { BatchedRenderer } from "three.quarks";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";
import { FreezeParticle } from "../../particles/FreezeParticle";
import { BaseMole } from "../BaseMole";
import { MoleAnimationController } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { IMoleState } from "./IMoleState";

export class FreezeState implements IMoleState {
    private nextState: IMoleState;
    private particle: FreezeParticle;
    private freezeTime: number;

    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer,
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly dieState: IMoleState,
    ) {
    }

    public enter(previousState: IMoleState): void {
        this.freezeTime = this.mole.freezed;
        this.nextState = previousState;
        this.animationController.stop();
        this.particle = new FreezeParticle(this.gameResources, this.particlesRenderer);
        this.particle.position.set(0, 0.5, -0.7);
        this.mole.add(this.particle);
        this.particle.play();
    }

    public exit(): void {
        this.mole.unfreeze();
        this.animationController.play();
    }

    public process(dt: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        this.freezeTime = Math.max(this.freezeTime - dt, 0);
        if (this.freezeTime == 0) {
            return this.nextState;
        }
        return this;
    }
}
